export default __webpack_public_path__ + "static/media/fa-regular-400.bc7401a8.woff";